/**
 *  关于 api 枚举
 */
export enum EnumApiActivity {
  /** 活动课详情 */
  ActivityCourse = '/activity/api/activity/{id}'
}
